/**
 * Used to apply `tailwindcss` intellisense.
 */
export function createTheme(input) {
    return input;
}
//# sourceMappingURL=create-theme.js.map